
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"27","height":"27","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"stroke":"#56BFC7","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M7.037 1.117H2.423a.923.923 0 00-.923.923v22.15c0 .51.413.924.923.924h4.614c.51 0 .923-.413.923-.923V2.04a.923.923 0 00-.923-.924zM13.498 4.81H8.884a.923.923 0 00-.923.922v18.46c0 .509.413.922.923.922h4.614c.51 0 .923-.413.923-.923V5.732a.923.923 0 00-.923-.923zM19.676 4.303l-3.581.897a.923.923 0 00-.672 1.119l4.481 17.906a.923.923 0 001.12.672l3.58-.896a.923.923 0 00.672-1.12l-4.48-17.906a.923.923 0 00-1.12-.672zM1.5 18.652h6.46M7.96 16.807h6.461M19.035 20.499l5.316-1.33"}})])])
          )
        }
      }
    